import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ArticleDiscount, defaultArticleDiscount } from "../../models/responses/articleDiscount";
import { interpretAsDecimal } from "../services/calculationsHelperService";

export interface ArticleDiscountState {
    articleDiscountList: ArticleDiscount[];
    articleDiscount: ArticleDiscount;
    isWaitingArticleDiscountPostResponse: boolean;
    isWaitingArticleDiscountPutResponse: boolean;
    totalQueryArticleDiscount: number;
    isWaitingArticleDiscountGetResponse: boolean;
    filteredArticleDiscountList: ArticleDiscount[];
}

const initialState: ArticleDiscountState = {
    articleDiscountList: [],
    articleDiscount: { ...defaultArticleDiscount },
    isWaitingArticleDiscountPostResponse: false,
    isWaitingArticleDiscountPutResponse: false,
    isWaitingArticleDiscountGetResponse: false,
    totalQueryArticleDiscount: 0,
    filteredArticleDiscountList: [],
};

const articleDiscountSlice = createSlice({
    name: 'articleDiscount',
    initialState,
    reducers: {
        setArticleDiscountList: (state, action: PayloadAction<{
            articleDiscounts: ArticleDiscount[];
        }>) => {
            action.payload.articleDiscounts.forEach(articleDiscount => {
                let forcedSalesPrice: number | null = parseFloat(articleDiscount.forcedSalesPrice ?? "-1");
                if (forcedSalesPrice < 0) forcedSalesPrice = null;
                articleDiscount.forcedSalesPrice = interpretAsDecimal(forcedSalesPrice).toFixed(2).toString();
            });

            state.articleDiscountList = (action.payload.articleDiscounts || initialState.articleDiscountList);
            return state;
        },
        setArticleDiscount: (state, action: PayloadAction<{
            articleDiscount: ArticleDiscount;
        }>) => {
            let articleDiscount: number | null = parseFloat(action.payload.articleDiscount.forcedSalesPrice ?? "-1");
            if (articleDiscount < 0)
                articleDiscount = null;

            action.payload.articleDiscount.forcedSalesPrice = interpretAsDecimal(articleDiscount).toFixed(2).toString();
            state.articleDiscount = action.payload.articleDiscount;
            return state;
        },
        setIsWaitingArticleDiscountPostResponse: (state, action: PayloadAction<boolean>) => {
            state.isWaitingArticleDiscountPostResponse = action.payload;
        },
        setIsWaitingArticleDiscountPutResponse: (state, action: PayloadAction<boolean>) => {
            state.isWaitingArticleDiscountPutResponse = action.payload;
        },
        setIsWaitingArticleDiscountGetResponse: (state, action: PayloadAction<boolean>) => {
            state.isWaitingArticleDiscountGetResponse = action.payload;
        },
        setFilteredArticleDiscountList: (state, action: PayloadAction<{ articleDiscounts: ArticleDiscount[] }>) => {
            state.filteredArticleDiscountList = (action.payload.articleDiscounts || []);
            return state;
        }
    },
});


export const {
    setArticleDiscountList,
    setArticleDiscount,
    setIsWaitingArticleDiscountPostResponse,
    setIsWaitingArticleDiscountPutResponse,
    setIsWaitingArticleDiscountGetResponse,
    setFilteredArticleDiscountList,
} = articleDiscountSlice.actions;

export default articleDiscountSlice.reducer;